import { RootState } from '../store';

export const adyenPaymentSelector = (state: RootState) => state.adyenPayment;
export const yunoPaymentSelector = (state: RootState) => state.yunoPayment;
export const paymentSelector = (state: RootState) => state.payment;
